import React from 'react';
import { Image } from 'react-datocms';
import { useRouter } from 'next/router';
import { LargeHeading, MediumHeading } from '@/components/Views/Heading';
import { NormalText } from '@/components/Views/Text';
import LargeButton from '@/components/Views/Buttons';
import RightArrow from '@/components/SVG/right-arrow.svg';
import { MUZOLOGY_SIGNUP_URL } from '@/lib/defaults';

interface Props {
    heading?: string;
    id?: string;

    featuredImage?: any;
}

const Mission = ({ heading, featuredImage, id }: Props) => {
    const router = useRouter();

    return (
        <section className='hero-container' id={id}>
            <LargeHeading as='h1' heading={heading} className='lg:text-center' />
            <div className='flex flex-col md:flex-row justify-between items-start mx-auto my-0 default-max-w md:mt-20'>
                <div className='w-full flex justify-center'>
                    <div className=''>
                        <Image data={{ ...featuredImage.responsiveImage, bgColor: '#ffffff00' }} priority={true} />
                    </div>
                </div>
                <div className='w-full xl:max-w-[475px] flex flex-col'>
                    <div className='w-full flex flex-col sm:flex-row md:flex-col gap-4'>
                        <div className=''>
                            <MediumHeading heading='Our Commitment' className='text-center sm:text-left' />
                            <NormalText>
                                Muzology is dedicated to providing students, educators, and parents with the highest quality learning solutions that create a
                                love of learning. We are committed to continuous improvement and innovation.
                            </NormalText>
                        </div>
                        <div className=''>
                            <MediumHeading heading='Our Mission' className='text-center sm:text-left' />
                            <NormalText>
                                Muzology’s mission is to use music and science to improve learning and unlock human potential. Muzology exists to eradicate
                                performance gaps in education and enable ALL learners to reach their full potential.
                            </NormalText>
                        </div>
                    </div>

                    <div className='flex flex-col xs:flex-row gap-4 justify-center md:justify-start items-center md:items-start mt-7 w-full'>
                        <LargeButton
                            className='purple-button h-[44px] w-[210px]'
                            text='Sign Up My Child'
                            href={MUZOLOGY_SIGNUP_URL}
                            rightArrow={true}
                            id={id + '-sign-up-my-child'}
                        />

                        <LargeButton
                            className='blue-button h-[44px] w-[210px]'
                            text='Sign Up As Educator'
                            href='/signup'
                            rightArrow={true}
                            id={id + '-sign-up-as-educator'}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Mission;
